import React from 'react';
import { Modal } from '@decisiv/ui-components';

/**
 * Reusable confirmation dialog for destructive actions.
 *
 * @param {boolean}   visible
 * @param {string}    title
 * @param {ReactNode} body
 * @param {string}    confirmText     Default: 'Confirm'
 * @param {string}    confirmIntent   KDS intent: 'primary' | 'danger'  Default: 'primary'
 * @param {function}  onConfirm
 * @param {function}  onCancel
 * @param {boolean}   isSubmitting    Disables the confirm button while in-flight
 * @param {string}    error           Optional error message shown inside the modal
 */
const AdminConfirmModal = ({
  visible,
  title,
  body,
  confirmText   = 'Confirm',
  confirmIntent = 'primary',
  onConfirm,
  onCancel,
  isSubmitting  = false,
  error         = null,
}) => (
  <Modal
    visible={visible}
    title={title}
    actions={[
      {
        text:     confirmText,
        kind:     confirmIntent,
        onClick:  onConfirm,
        disabled: isSubmitting,
      },
      {
        text:    'Cancel',
        kind:    'secondary',
        onClick: onCancel,
      },
    ]}
  >
    {body}
    {error && (
      <div style={{ marginTop: 12, padding: '8px 12px', background: '#fff3f3', borderRadius: 4, border: '1px solid #f5c6cb', fontSize: 13, color: '#c0392b' }}>
        {error}
      </div>
    )}
  </Modal>
);

export default AdminConfirmModal;
